/**
 * fetch with bounded exponential backoff on throttle-class responses.
 *
 * The dev account runs at a 10-concurrent-executions Lambda limit, so a
 * Trends-page load (digest + many chart cards) can momentarily exceed it and
 * individual requests come back 429/503. Those are races, not failures —
 * retrying with jittered backoff lets the burst drain. Any other status is
 * returned untouched (no silent degradation; callers keep their error paths).
 */
const RETRY_STATUSES = new Set([429, 503]);

export async function fetchWithRetry(
  input: RequestInfo | URL,
  init?: RequestInit,
  retries = 3,
  baseDelayMs = 400,
): Promise<Response> {
  let attempt = 0;
  for (;;) {
    const r = await fetch(input, init);
    if (!RETRY_STATUSES.has(r.status) || attempt >= retries) return r;
    const delay = baseDelayMs * 2 ** attempt + Math.random() * 250;
    await new Promise((resolve) => setTimeout(resolve, delay));
    attempt++;
  }
}
